import { BillingFrequency, BillingStatus, Currency } from '@css-xp/graphtypes/src/generated-types-new';

export const getPricingPlanFilterOptionsForNativeCatalog = (isMultiCurrencyEnabled: boolean) => {
  const pricingPlans: Record<any, any>[] = [
    {
      key: 'status',
      value: BillingStatus.ACTIVE,
    },
    {
      key: 'billingFrequency',
      value: BillingFrequency.MONTHLY,
    },
  ];
  if (!isMultiCurrencyEnabled) {
    pricingPlans.push({
      key: 'currency',
      value: Currency.USD,
    });
  }
  return pricingPlans;
};
